

export const analytics = {
    visitors: {
        series: {
            'this-year': [
                {
                    name: 'Visitors',
                    data: []
                },
            ],
            'last-year': [
                {
                    name: 'Visitors',
                    data: []
                },
            ],
        },
    },
    conversions: {
        amount: 4123,
        labels: [],
        series: [
        ],
    },
    impressions: {
        amount: 46085,
        labels: [],
        series: [
        ],
    },
    visits: {
        amount: 62083,
        labels: [],
        series: [],
    },
    visitorsVsPageViews: {
        overallScore: 472,
        averageRatio: 45,
        predictedRatio: 55,
        series: []
    },
    newVsReturning: {
        uniqueVisitors: 30,
        series: [20, 80],
        labels: [
            'Absent',
            '',
        ],
    },
    gender: {
        uniqueVisitors: 30,
        series: [60, 40],
        labels: [
            'Present',
            '',
        ],
    },
    age: {
        uniqueVisitors: 30,
        series: [35, 65],
        labels: [
            'Late',
            '',
        ],
    },
    language: {
        uniqueVisitors: 30,
        series: [60, 20],
        labels: [
            'Working Days',
            'Leave Days',
        ],
    },
};
